import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export interface SubjectiveResponse {
  documentReferences: fhirTypes.DocumentReference[];
}

export const useSubjective = (encounterId?: string) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<SubjectiveResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<SubjectiveResponse>(
          "/charting/subjective/",
          { params: { encounterId } },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.Subjective.DEFAULT({
        patientId,
        encounterId,
      }),
    },
  });
};
